import { useEffect } from 'react';

const CHATBASE_ID = 'k8INjptaT209w7FGeRRfB';
const CHATBASE_SELECTOR =
  '[id*="chatbase"], [class*="chatbase"], iframe[src*="chatbase"]';
const CHATBASE_WINDOW_SELECTOR =
  '[id*="chatbase-bubble-window"], [class*="chatbase-bubble-window"], [class*="chatbase-window"]';

const setWidgetVisibility = (visible) => {
  const chatbaseElements = document.querySelectorAll(CHATBASE_SELECTOR);
  chatbaseElements.forEach((el) => {
    el.style.display = visible ? '' : 'none';
  });
};

const collapseChatWindow = () => {
  try {
    if (window.chatbase) {
      window.chatbase('close');
    }
  } catch (error) {
    // Ignore API errors and fallback to DOM-based collapse.
  }

  const expandedPanels = document.querySelectorAll(CHATBASE_WINDOW_SELECTOR);
  expandedPanels.forEach((el) => {
    el.style.display = 'none';
  });
};

export const forceHideChatbaseWidget = () => {
  collapseChatWindow();
  setWidgetVisibility(false);

  window.setTimeout(() => {
    collapseChatWindow();
    setWidgetVisibility(false);
  }, 150);
};

const ChatbaseWidget = ({ isAuthenticated = false }) => {
  // Carga e inicializacion del script solo una vez.
  useEffect(() => {
    if (!isAuthenticated) {
      forceHideChatbaseWidget();
      return;
    }

    if (!window.chatbase || window.chatbase('getState') !== 'initialized') {
      window.chatbase = (...args) => {
        if (!window.chatbase.q) {
          window.chatbase.q = [];
        }
        window.chatbase.q.push(args);
      };
      window.chatbase = new Proxy(window.chatbase, {
        get(target, prop) {
          if (prop === 'q') {
            return target.q;
          }
          return (...args) => target(prop, ...args);
        }
      });
    }

    const loadScript = () => {
      if (document.getElementById(CHATBASE_ID)) {
        return;
      }

      const script = document.createElement('script');
      script.src = 'https://www.chatbase.co/embed.min.js';
      script.id = CHATBASE_ID;
      script.setAttribute('chatbotId', CHATBASE_ID);
      script.setAttribute('domain', 'www.chatbase.co');
      script.defer = true;
      document.body.appendChild(script);
    };

    if (document.readyState === 'complete') {
      loadScript();
      return;
    }

    window.addEventListener('load', loadScript);
    return () => window.removeEventListener('load', loadScript);
  }, [isAuthenticated]);

  useEffect(() => {
    if (!isAuthenticated) {
      forceHideChatbaseWidget();
      return;
    }

    setWidgetVisibility(true);
    collapseChatWindow();
  }, [isAuthenticated]);

  useEffect(
    () => () => {
      forceHideChatbaseWidget();
    },
    []
  );

  // Componente invisible - el widget se inyecta en el DOM
  return null;
};

export default ChatbaseWidget;
